module.exports = __webpack_public_path__ + "media/images/loadingAnimation-1fb1886d88a2b1bcc6a8117b1b18ce0f.gif";